import NavBarComponent from "../components/NavBarComponent";
import ShowAllClients from "../components/ShowAllClients";

function Home() {
  return (
    <>
      <NavBarComponent />
      <ShowAllClients />
    </>
  );
}

export default Home;